module.exports = __webpack_public_path__ + "40e5d38e80cef4c7ba6c85bc7b5b83c2.MP3";